import { useState } from 'react'

import ApproverHistoryTimelineCommon from './ApprovalHistoryTimeLineCommon'

const ApproverHistoryTimelineCommonContainer = (props?: any) => {
    const approvalHistory = props?.approvalHistory
    const isOrderDetail = props?.isOrderDetail
    const [collapse, setCollapse] = useState(true);

    const onCollapse = () => {
        setCollapse(!collapse)
    }

    return <ApproverHistoryTimelineCommon
        approvalHistory={approvalHistory}
        isOrderDetail={isOrderDetail}
        onCollapse={onCollapse}
        collapse={collapse}
    />
}

export default ApproverHistoryTimelineCommonContainer